/*
  fb-added-sheet.js — Mobile-Bottom-Sheet nach "In den Warenkorb" (04.07.).
  Laedt sections/fb-added-sheet.liquid per Section-Rendering-API und zeigt es
  als Sheet (nur < 768px). Aufruf: window.fbAddedSheet.show() (fb-configurator.js).
  Drawer-Aktualisierung laeuft separat ueber cart:refresh {open:false}.
  Review-Fixes 04.07.: K1 Fallback auf Drawer bei Fetch-Fehler, K2 Fokus-Management
  (initialer Fokus, trapFocus, Fokus-Rueckgabe), W2 Escape-Listener sauber,
  W6 einheitlicher Root-Pfad.
*/
(function () {
  'use strict';
  var MOBILE = window.matchMedia('(max-width: 767px)');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var host = null;
  var opener = null;
  var escHandler = null;

  // Fix 09.07.: Mit ctx {productUrl, variantId} rendert die Section ueber die PDP-URL.
  // Dadurch ist im Liquid der `product`-Kontext verfuegbar und das Sheet erkennt den
  // gerade hinzugefuegten Hauptartikel eindeutig. Frueher lief das ueber die Cart-Property
  // `_bundle_role` — die verhinderte aber Shopifys Zusammenfassen gleicher Zeilen.
  // Ohne ctx greift der alte Pfad (Fallback im Liquid: neueste Cart-Zeile).
  function sheetURL(ctx) {
    if (ctx && ctx.productUrl) {
      var sep = ctx.productUrl.indexOf('?') === -1 ? '?' : '&';
      var url = ctx.productUrl + sep + 'sections=fb-added-sheet';
      if (ctx.variantId) url += '&variant=' + encodeURIComponent(ctx.variantId);
      return url;
    }
    return ROOT + '?sections=fb-added-sheet';
  }

  function fetchSheetHTML(ctx) {
    // WICHTIG: KEIN 'Accept: application/json'-Header! Auf /products/<handle>-URLs liefert
    // Shopify mit diesem Header das Produkt-JSON ({product:...}) statt der Section-
    // Rendering-Antwort (der ?sections=-Parameter wird ignoriert) -> Sheet bleibt leer,
    // nichts erscheint. Ohne den Header rendert ?sections=fb-added-sheet korrekt (im
    // Live-Test verifiziert 06.08.2026). Response ist auch ohne Header valides JSON.
    return fetch(sheetURL(ctx))
      .then(function (r) { return r.json(); })
      .then(function (j) { return j['fb-added-sheet'] || ''; });
  }

  function lock(on) {
    document.documentElement.classList.toggle('fb-added-lock', !!on);
  }

  function openDrawerFallback() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  }

  // ---- v1 Quick-Add Helfer ----
  var QTY_MAX = 100000;
  function clampQty(n) { n = parseInt(n, 10); if (isNaN(n) || n < 1) n = 1; if (n > QTY_MAX) n = QTY_MAX; return n; }

  function fetchConfig() {
    if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.fetchConfig === 'function') {
      var c = FoxTheme.utils.fetchConfig('javascript'); c.method = 'POST'; return c;
    }
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
  }

  // data-fb-tiers Format: "menge:preis,menge:preis" (Preis in Euro) -> Stufen in Cent
  function parseTiers(raw) {
    var out = [];
    if (!raw) return out;
    raw.split(',').forEach(function (t) {
      var pp = t.split(':');
      if (pp.length < 2) return;
      var q = parseInt(String(pp[0]).replace(/[^0-9]/g, ''), 10);
      var pc = Math.round(parseFloat(String(pp[1]).replace(',', '.').replace(/[^0-9.]/g, '')) * 100);
      if (!isNaN(q) && !isNaN(pc) && q >= 2 && pc > 0) out.push({ q: q, price: pc });
    });
    return out;
  }

  function moneyDE(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }

  // guenstigste anwendbare Staffelstufe fuer Menge q (nur wenn < Basispreis; Guard wie Function/Theme)
  function unitFor(base, tiers, q) {
    var best = base;
    tiers.forEach(function (t) { if (q >= t.q && t.price < base && t.price < best) best = t.price; });
    return best;
  }

  function renderCardPrice(card) {
    if (!card) return;
    var el = card.querySelector('[data-fb-cardprice]');
    if (!el) return;
    var base = parseInt(card.getAttribute('data-fb-base'), 10) || 0;
    var tiers = parseTiers(card.getAttribute('data-fb-tiers'));
    var input = card.querySelector('[data-fb-cqty]');
    var q = clampQty(input ? input.value : 1);
    var unit = unitFor(base, tiers, q);
    el.textContent = (unit < base ? 'ab ' : '') + moneyDE(unit);
  }

  function announce(msg) {
    var live = host && host.querySelector('[data-fb-live]');
    if (live) live.textContent = msg;
  }

  function quickAdd(btn) {
    if (btn.disabled || btn.getAttribute('data-done') === '1') return;
    var card = btn.closest('[data-fb-card]');
    if (!card) return;
    var vid = card.getAttribute('data-fb-vid');
    var input = card.querySelector('[data-fb-cqty]');
    var qty = clampQty(input ? input.value : 1);
    if (!vid) return;
    btn.disabled = true; btn.classList.add('is-loading');
    var cfg = fetchConfig();
    cfg.body = JSON.stringify({ items: [{ id: vid, quantity: qty }] });
    fetch(ROOT + 'cart/add.js', cfg)
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) { btn.disabled = false; announce('Konnte nicht hinzugefügt werden.'); return; }
        btn.setAttribute('data-done', '1');
        btn.setAttribute('aria-disabled', 'true');
        var idle = card.querySelector('.fb-added__add-idle'); if (idle) idle.hidden = true;
        var done = card.querySelector('.fb-added__add-done'); if (done) done.hidden = false;
        card.classList.add('is-added');
        announce((btn.getAttribute('data-fb-title') || 'Artikel') + ' hinzugefügt');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.disabled = false; announce('Konnte nicht hinzugefügt werden.'); });
  }

  function close() {
    if (!host) return;
    var h = host;
    host = null;
    if (escHandler) { document.removeEventListener('keydown', escHandler); escHandler = null; }
    var root = h.querySelector('[data-fb-added]');
    if (root) {
      root.classList.remove('is-open');
      if (window.FoxTheme && FoxTheme.a11y && typeof FoxTheme.a11y.removeTrapFocus === 'function') {
        try { FoxTheme.a11y.removeTrapFocus(); } catch (e) {}
      }
    }
    lock(false);
    if (opener && typeof opener.focus === 'function') { try { opener.focus(); } catch (e) {} }
    opener = null;
    setTimeout(function () { h.remove(); }, 300);
  }

  function wire(hostEl) {
    hostEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-fb-added-close]')) { close(); return; }
      var cartBtn = e.target.closest('[data-fb-sheet-cart]');
      if (cartBtn) { close(); openDrawerFallback(); return; }
      var step = e.target.closest('[data-fb-cq]');
      if (step) {
        var card = step.closest('[data-fb-card]');
        var input = card && card.querySelector('[data-fb-cqty]');
        if (input) {
          input.value = clampQty((parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-fb-cq'), 10));
          renderCardPrice(card);
        }
        return;
      }
      var addBtn = e.target.closest('[data-fb-add]');
      if (addBtn) { quickAdd(addBtn); return; }
    });
    hostEl.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-fb-cqty]');
      if (!inp) return;
      inp.value = clampQty(inp.value);
      renderCardPrice(inp.closest('[data-fb-card]'));
    });
    var cards = hostEl.querySelectorAll('[data-fb-card]');
    for (var i = 0; i < cards.length; i++) renderCardPrice(cards[i]);
    escHandler = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', escHandler);
  }

  function show(ctx) {
    if (!MOBILE.matches) return false;
    opener = document.activeElement;
    fetchSheetHTML(ctx)
      .then(function (html) {
        if (!html || html.indexOf('data-fb-added') === -1) { openDrawerFallback(); return; }
        close();
        host = document.createElement('div');
        host.innerHTML = html;
        document.body.appendChild(host);
        wire(host);
        lock(true);
        var root = host.querySelector('[data-fb-added]');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!root) return;
            root.classList.add('is-open');
            var x = root.querySelector('.fb-added__x');
            if (x) { try { x.focus(); } catch (e) {} }
            if (window.FoxTheme && FoxTheme.a11y && typeof FoxTheme.a11y.trapFocus === 'function') {
              try { FoxTheme.a11y.trapFocus(root.querySelector('.fb-added__sheet') || root, x); } catch (e) {}
            }
          });
        });
      })
      .catch(function () { openDrawerFallback(); });
    return true;
  }

  window.fbAddedSheet = { show: show, close: close };
})();
